import { Link, useSearchParams } from "react-router-dom";

import { AuthLayout } from '../../components/layout/AuthLayout';

export function RegisterPendingPage() {
  const [params] = useSearchParams();
  const email = params.get("email")?.trim() || "";

  return (
    <AuthLayout title="Sprawdź skrzynkę e-mail">
      <p className="auth__subtitle" data-testid="register-pending">
        Wysłaliśmy link potwierdzający
        {email ? (
          <>
            {" "}
            na adres <strong className="auth__email">{email}</strong>
          </>
        ) : null}
        . Kliknij go, aby aktywować konto (ważny 1&nbsp;h).
      </p>
      <p className="auth__footer">
        <Link to="/login">Wróć do logowania</Link>
      </p>
    </AuthLayout>
  );
}
